import Select, { MultiValue } from 'react-select'
import { ActionMeta, MenuPlacement } from 'react-select/dist/declarations/src/types'
import { TooltipSelectOption } from './tooltip-select.model'
import Label from './components/Label'
import Tooltip from './components/Tooltip'
import useReactTooltipSelect from './hooks/useReactTooltipSelect'
import { handleOptionChange } from './tooltip-select.helper'

type Props = {
	getDataHandler: string
	placeholder: string
	menuPlacement: MenuPlacement
}

const TooltipSelect = ({ getDataHandler, placeholder, menuPlacement }: Props) => {
	const { options, isLoading, menuIsOpen, setOptions, setMenuIsOpen, handleSetSentiment } =
		useReactTooltipSelect(getDataHandler)

	if (isLoading)
		return (
			<div className="text-center">
				<i className="fa fa-spinner fa-spin"></i>
			</div>
		)

	if (!options) return null

	const { MultiValueLabel } = Label(options)
	const { MultiValueContainer } = Tooltip(options, handleSetSentiment)

	return (
		// @ts-ignore
		<Select
			className="z-20"
			closeMenuOnSelect={false}
			components={{ MultiValueContainer, MultiValueLabel }}
			isMulti
			options={options}
			defaultValue={options.filter((option) => option.selected)}
			placeholder={placeholder}
			menuPlacement={menuPlacement}
			menuIsOpen={menuIsOpen}
			onChange={(_: MultiValue<TooltipSelectOption>, action: ActionMeta<TooltipSelectOption>) =>
				handleOptionChange(options, action, setOptions)
			}
			onFocus={() => setMenuIsOpen(true)}
			onBlur={() => setMenuIsOpen(false)}
		/>
	)
}

export default TooltipSelect
